import ApiService from "@/utils/request";

export const SearchServe = {
  policySearch(params = {}) {
    return ApiService.query("/policy/v2/inner/guidelines/", {
      ...params,
      // page: 1,
      // size: 10,
      // open_sts: "已开通",
      // secondary_industry: JSON.stringify(["A0314"]),
    });
  },
  areaList() {
    return ApiService.get("/policy/v2/inner/mof_div/");
  },
  fitObject() {
    return ApiService.get("/policy/v2/fit_object/");
  },
  industry() {
    return ApiService.get("/policy/v2/industry/");
  },
};
